import { styled } from '../../../theme/stitches.config';

export const StyledLabel = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});
